import { ADT } from './dimensions';
import { AdtBody } from './AdtBody';
import { ADT_LAYOUT, ADT_WHEELS } from './wheels';

const adt6Preset = {
  id: 'adt-6-standard',
  silhouette: 'adt',
  renderModelKey: 'adt',
  renderLayoutKey: 'adt-6-wheel-v1',
  label: '3 axles, all single fitment',
  layout: ADT_LAYOUT,
  wheels: ADT_WHEELS,
  camera: {
    position: [11.2, 5.4, 10.2],
    target: [0, 1.7, 0],
    minDistance: 7.5,
    maxDistance: 30,
    fov: 32,
  },
  stage: { extent: ADT.length, contactHeight: 1.58 },
  skeleton: 'axles',
  Body: AdtBody,
};

export { adt6Preset };
